/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect } from "react";
import { deleteCache, setCache } from "../cache";

export type CacheHookArgs = {
    cache?: boolean;
    cacheKey: any;
    value: any;
};

export const useCache = ({ cache = false, cacheKey, value }: CacheHookArgs) => {
    useEffect(() => {
        if (!cache) {
            return;
        }

        if (value) {
            setCache(cacheKey as any, value);
        } else {
            deleteCache(cacheKey as any);
        }
    }, [value, cache, cacheKey]);
};
